import { render, staticRenderFns } from "./V2ProfileDocument.vue?vue&type=template&id=e19c928a&scoped=true&"
import script from "./V2ProfileDocument.vue?vue&type=script&lang=js&"
export * from "./V2ProfileDocument.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileDocument.vue?vue&type=style&index=0&id=e19c928a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19c928a",
  null
  
)

export default component.exports